import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {map, Observable} from "rxjs";
import {iResult} from "../entity/interfaces/allgemein";
@Injectable({
  providedIn: 'root'
})
export class DatenUploaderService {

  constructor(private api: ApiService) { }

  public datenUpload(body : object,adressEnd: string): Observable<iResult> {
    return this.api.post(body,adressEnd)
      .pipe(map(resp => {
        if (resp.success) {
          return resp;
        } else {
          return resp;
        }
      }));
  }


}
